(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["background-video"] && !Shopify.designMode) return;
  try {
    class BackgroundVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('[data-video-toggle]');
      if (!this.video || !this.toggle) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.userPaused = true;
        this.video.removeAttribute('autoplay');
        this.video.pause();
      }

      this.toggle.addEventListener('click', () => {
        this.userPaused = !this.video.paused;
        if (this.userPaused) this.video.pause();
        else this.video.play().catch(() => {});
      });
      this.video.addEventListener('play', () => this.sync());
      this.video.addEventListener('pause', () => this.sync());
      this.sync();

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          if (this.userPaused) return;
          if (entry.isIntersecting) this.video.play().catch(() => {});
          else this.video.pause();
        });
        this.observer.observe(this);
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    sync() {
      const paused = this.video.paused;
      this.toggle.setAttribute('aria-label', paused ? this.dataset.labelPlay : this.dataset.labelPause);
      this.toggle.querySelector('[data-icon-pause]').hidden = paused;
      this.toggle.querySelector('[data-icon-play]').hidden = !paused;
    }
  }

  if (!customElements.get('background-video')) customElements.define('background-video', BackgroundVideo);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["image-crossfade"] && !Shopify.designMode) return;
  try {
    class ImageCrossfade extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.image-crossfade__slide')];
      this.toggle = this.querySelector('[data-crossfade-toggle]');
      if (this.slides.length < 2 || !this.toggle) return;

      this.index = 0;
      this.delay = Number(this.dataset.interval) || 2000;
      this.userPaused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.visible = !('IntersectionObserver' in window);
      this.toggle.hidden = false;

      this.toggle.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.update();
      });
      this.onVisibilityChange = () => this.update();
      document.addEventListener('visibilitychange', this.onVisibilityChange);

      if (!this.visible) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.update();
        });
        this.observer.observe(this);
      }
      this.update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      this.stop();
    }

    update() {
      if (!this.userPaused && this.visible && !document.hidden) this.start();
      else this.stop();
      this.sync();
    }

    start() {
      if (!this.timer) this.timer = setInterval(() => this.next(), this.delay);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    // The old photo stays underneath while the new one fades in over it.
    next() {
      const current = this.slides[this.index];
      this.index = (this.index + 1) % this.slides.length;
      this.slides.forEach((slide) => slide.classList.remove('is-previous'));
      current.classList.replace('is-active', 'is-previous');
      this.slides[this.index].classList.add('is-active');
    }

    sync() {
      const paused = this.userPaused;
      this.toggle.setAttribute('aria-label', paused ? this.dataset.labelPlay : this.dataset.labelPause);
      this.toggle.querySelector('[data-icon-pause]').hidden = paused;
      this.toggle.querySelector('[data-icon-play]').hidden = !paused;
    }
  }

  if (!customElements.get('image-crossfade')) customElements.define('image-crossfade', ImageCrossfade);
  } catch(e) { console.error(e); }
})();

})();
